import React from "react";
import { useNavigate } from "react-router-dom";
import "./Footer.css";
import footer_logo from "../Assets/Frontend_Assets/footerlogodone.png";
// import instagram from "../Assets/Frontend_Assets/instagram_icon.png";

const Footer = () => {
  const navigate = useNavigate();
const handleWhatsAppClick = async () => {
  const currentUrl = window.location.href;
  const phoneNumber = "923365338714"; // Your number without +

  try {
    await navigator.clipboard.writeText(currentUrl);

    const message = `Hello, I am interested in this product: ${currentUrl}`;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(whatsappUrl, "_blank");
  } catch (error) {
    console.error("Copy failed", error);
  }
};
  return (
    <footer className="footer">
       <div className="overlay"></div>
      <div className="footer-container">

        {/* BRAND */}
        <div className="footer-brand">
          <img src={footer_logo} alt="Hesham Ali Collection" />
          <h3>Glamour Fashion</h3>
          <p>
            Premium fashion store delivering quality & style across Pakistan.
          </p>
        </div>

        {/* CONTACT US */}
        <div className="footer-column">
          <h4>Contact Us</h4>
          <p>📍 Address: Malkabad Shopping Center , Ground Floor ,Shop #G-41 6th Road Rawalpindi</p>
          <p>📧 Bazaartvteam@gmail.com</p>
          <p>📞 +92336-533-8714</p>
            <p>📞 +92334-607-6709</p>
        </div>

        {/* INFORMATION */}
        <div className="footer-column">
          <h4>Information</h4>
          <ul>
            <li onClick={() => navigate("/Blogs")}>Blogs</li>
            <li onClick={() => navigate("/about")}>About Us</li>
            {/* <li onClick={() => navigate("/catalogue")}>Catalogues</li> */}
            <li onClick={() => navigate("/privacy-policy")}>Privacy Policy</li>
            <li onClick={() => navigate("/terms")}>Terms & Conditions</li>
          </ul>
        </div>

        {/* CUSTOMER SERVICE */}
        <div className="footer-column">
          <h4>Customer Services</h4>
          <ul>
            <li onClick={() => navigate("/faq")}>FAQs</li>
            <li onClick={() => navigate("/my-orders")}>Order Tracking</li>
            {/* <li onClick={() => navigate("/store-locator")}>Store Locator</li> */}
            <li onClick={() => navigate("/ContactUs")}>Contact Us</li>
          </ul>
        </div>
      </div>

      {/* SOCIAL */}
      {/* <div className="footer-social">
        <img src={instagram} alt="Instagram" />
        <img src={instagram} alt="Instagram" />
        <img src={instagram} alt="Instagram" />
      </div> */}

      {/* COPYRIGHT */}
      <div className="footer-bottom">
        <hr />
        <p>© 2026 Glamour Fashion. All rights reserved.</p>
      </div>
      {/* Floating WhatsApp Button */}
<button className="whatsapp-float" onClick={handleWhatsAppClick}>
   💬
</button>
    </footer>
  );
};

export default Footer;
